import { createFileRoute } from "@tanstack/react-router";
import { Ticket } from "lucide-react";
import { z } from "zod";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { EventsTab } from "@/features/booking/modules/events/events-tab";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/booking/events/")({
  loader: () => ({ crumb: m.booking_events_page_title() }),
  validateSearch: z.object({ bookingId: z.string().optional() }),
  component: EventsPage,
});

function EventsPage() {
  return (
    <PageShell icon={Ticket} title={m.booking_events_page_title()} description={m.booking_events_page_description()}>
      <EventsTab />
    </PageShell>
  );
}
